export class EmailAttributes{
    to?: string;
    cc?: string[];
    bcc?: string[];
}
export class CostReviewOperationsResponseBase{
    errorCode: number = 0;
    currentReviewer: string = '';
}

export class CostReviewApproveResponse extends CostReviewOperationsResponseBase{
    isApproved?: boolean;
    emailAttributes?: EmailAttributes;
}

export class CostReviewDenyResponse extends CostReviewOperationsResponseBase{
    isDenied?: boolean;
    emailAttributes?: EmailAttributes;
}

export class CostReviewUpdateTRRStatusResponse extends CostReviewOperationsResponseBase{
    isTRRUpdated?: boolean;
}